export enum CommunicationChannel {
  AMB = 'amb',
  SMS = 'sms',
  WHATS_APP = 'whatsapp',
}
